import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { SearchNormal1, TableDocument, Hierarchy3 } from 'iconsax-react';
import { ChangeEvent, useEffect, useState } from 'react';
import { ThemeMode } from 'types/config';
import MainCard from 'components/MainCard';
import SimpleBar from 'components/third-party/SimpleBar';
import ChatHeader from './ChatHeader';
import Grid from '@mui/material/Grid';
import { CardActions, IconButton, styled, Tab, TablePagination } from '@mui/material';
import { Button } from '@mui/material';
import TeamForm from './TeamForm';
import FormPlaceholder from './FormPlaceholder';
import useApi from 'hooks/useApi';
import useClientAutoSelector from 'hooks/useClientAutoSelector';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import LoadingPlaceholder from './LoadingPlaceholder';
import TeamsList from './TeamsList';
import { Tabs } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ClientFilter from 'components/ClientFilter';
// import ManageTeamUsers from './TeamUsers';
import QuikFlowPage from '../quikflow';
import TeamNotificationSettings from './TeamNotificationSettings';
import { PERMISSIONS } from 'contexts/PermissionContext';
import { PermissionWrapper } from 'components/PermissionComponents';
import useSelection from 'hooks/useSelection';
// import PermissionGuard from 'utils/route-guard/PermissionGuard';
import HideFormFields from './HideFormFields';
import ObjectDetectionSettings from './ObjectDetectionSettings';
import AssignmentMessaging from './AssignmentMessaging';
import SmartSheetConfig from './SmartSheetConfig';
import DetectionSettings from './DetectionSettings';
import VerificationSettings from './VerificationSettings';
import DefaultStepsSettings from './DefaultStepsSettings';
import MonitoringSettings from './MonitoringSettings';
import LocationTrackingSettings from './LocationTrackingSettings';
import EscalationDefaultSettings from './EscalationDefaultSettings';
import ChildTxnStartStepSettings from './ChildTxnStartStepSettings';
import TeamClone from './TeamClone';

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '8px',
  padding: '10px 8px',
  backgroundColor: theme.palette.grey[300],
  transition: 'all 0.3s ease',
  minHeight: '36px',
  marginRight: '5px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      color: '#fff'
    }
  },
  '&:hover': {
    color: theme.palette.primary.main
  }
}));

const INNER_DRAWER_WIDTH = 320;

const TeamsPage = ({ handleDrawerOpen }: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { teamUid } = useParams();
  const location = useLocation();
  const { getTeams, showToast, getTeamByUid } = useApi();
  
  const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));

  // Inner drawer toggle state - closed by default below 'lg', open by default above it
  const [innerDrawerOpen, setInnerDrawerOpen] = useState(!matchDownLG);

  useEffect(() => {
    setInnerDrawerOpen(!matchDownLG);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

const [teamLoading, setTeamLoading] = useState(true);
  const [tabSelected, setTabSeelcted] = useState('details');
  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [client, setClient] = useState<any>(null);
  const [selectedTeam, setSelectedTeam] = useState<any>(null);
  const [pagination, setPagination] = useState<{ page: number; size: number }>({
    page: 0,
    size: 10
  });

  // Auto-select client if there's only one available (important for users without dashboard access)
  useClientAutoSelector();

  // Get client options from global context
  const { clientOptions } = useSelection();

  const [clientUID, setClientUID] = useState<string | null>(null);
  const [pageCount, setPageCount] = useState<number>(0);
  const [teams, setTeams] = useState<any[]>([]);

  const drawerBG = theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'white';

  const [search, setSearch] = useState<string | undefined>('');
  const handleSearch = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | undefined) => {
    const newString = event?.target.value;
    setSearch(newString);

    setPagination((prev) => ({ ...prev, page: 0 }));
  };
  const onClickAction = (team = null) => {
    setShowForm(false);
    setIsLoading(true);
    console.log("team",team)
    setSelectedTeam(team);
    setTabSeelcted('details');
    setTimeout(() => {
      if (!team) {
        navigate('/teams');
      }
      setShowForm(true);
      setIsLoading(false);
    });
  };
  

    const loadClients = async () => {
    // Client loading is now handled by SelectionContext
    // Auto-select first client if available and no client is selected
    if (clientOptions.length === 1 && !client) {
      setClient(clientOptions[0].uid);
    }
  };

useEffect(() => {
  loadClients();
},[clientOptions])

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPagination((prev) => ({ ...prev, page: 0, size: Number(event.target.value) }));
  };

  const resetForm = (client = null) => {
    setSelectedTeam(null);
    setShowForm(false);
    setTabSeelcted('details');
    navigate('/teams');
    loadTeams();
  };

  const loadTeamById = async (clientId: string) => {
    setShowForm(false);
    setIsLoading(true);
    let teamResp = await getTeamByUid(clientId);
       
    let { success, data, message } = teamResp;
  
    if (success) {
      onClickAction({ ...data });
      setClientUID(data?.client?.uid || null);
      console.log(data?.client?.uid, 'clientUID');
      setShowForm(true);
      setIsLoading(false);
    } else {
      showToast(message, 'error');
    }
  };

  const loadTeams = async () => {

    try {
      let teamResp = await getTeams({
        ...pagination,
        page: pagination.page + 1,
        clients: client ? [client] : [],
        keyword: search || ''
      });

      const { success, data, message } = teamResp;

      if (success) {
        let { count, teams } = data;
        setPageCount(count);
        setTeams(teams);
      } else {
        showToast(message, 'error');
      }

      setTeamLoading(false);
      setIsLoading(false)
    } catch (error: any) {
      showToast(error.message, 'error');
    }
  };

  useEffect(() => {
    loadTeams();
  }, [pagination, search, client]); 

  useEffect(() => {
    if (teamUid) {
      loadTeamById(teamUid);
    }
  }, [teamUid]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabSeelcted(newValue);
    if (newValue === 'flow' && teamUid) {
      setTabSeelcted('flow');
    }
  };

  // ── Process settings tabs: primary pills stay inline; the remaining (less
  // frequent) sections live in a "More" dropdown so the row never overflows. ──
  const PRIMARY_TAB_VALUES = ['details', 'flow', 'defaultSteps'];
  const MORE_TABS: { value: string; label: string }[] = [
    { value: 'notifications', label: 'Notifications' },
    { value: 'sheets', label: 'Integration' },
    { value: 'hideFormFields', label: 'Hide Form Fields' },
    { value: 'assignmentMessaging', label: 'Assignment Messaging' },
    { value: 'detection', label: 'AI Detection' },
    // On-device camera classes (what the phone can recognise). Platform-wide
    // rather than per process, but this is where detection is configured.
    { value: 'objectDetection', label: 'Object Detection' },
    { value: 'verification', label: 'Identity Verification' },
    { value: 'monitoring', label: 'Monitoring & Alerts' },
    { value: 'locationTracking', label: 'Location Tracking' },
    { value: 'escalationDefault', label: 'Escalation' },
    { value: 'childStartStep', label: 'Child Start Step' },
    { value: 'clone', label: 'Clone' },
  ];
  const activeMoreTab = MORE_TABS.find((t) => t.value === tabSelected);
  const handleMoreOpen = (e: React.MouseEvent<HTMLElement>) => setMoreAnchorEl(e.currentTarget);
  const handleMoreClose = () => setMoreAnchorEl(null);
  const handleMoreSelect = (value: string) => {
    setTabSeelcted(value);
    setMoreAnchorEl(null);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const clientParam = params.get('client');
    if (clientParam && clientParam !== client) {
      setClient(clientParam);
      setPagination((prev) => ({ ...prev, page: 0 }));
    }
  }, [location.search]);

  return (
    <Box sx={{ display: 'flex', paddingX: '5px', padding: '8px', position: 'relative', overflow: 'hidden' }}>
      {/* Toggle Button - Always visible, sticks to left edge when inner drawer is closed */}
      <IconButton
        onClick={() => setInnerDrawerOpen(!innerDrawerOpen)}
        sx={{
          position: 'absolute',
          left: innerDrawerOpen ? INNER_DRAWER_WIDTH - 16 : 0,
          top: 17,
          marginInline: 3,
          color:'#fff',
          backgroundColor: '#1D2630',
          
          zIndex: 1201,
         boxShadow: 2,
          '&:hover': {
            bgcolor: '#1D2630',
          },
          transition: 'all 0.3s ease',
          width: 28,
          height: 28,
          borderRadius: innerDrawerOpen ? '20%' : '0 8px 8px 0',  
        }}
      >
        {innerDrawerOpen ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
      </IconButton>

      <Box
        sx={{
          width: innerDrawerOpen ? INNER_DRAWER_WIDTH : 0,
          minWidth: innerDrawerOpen ? INNER_DRAWER_WIDTH : 0,
          flexShrink: 0,
          transition: 'all 0.3s ease',
          overflow: 'hidden',
        }}
      >
        <Drawer
          sx={{
            width: INNER_DRAWER_WIDTH,
            flexShrink: 0,
            zIndex: 0,
            '& .MuiDrawer-paper': {
              height: 'auto',
              width: INNER_DRAWER_WIDTH,
              boxSizing: 'border-box',
              position: 'relative',
              border: 'none',
              borderRadius: '12px 0 0 12px',
            },

        }}
        variant="persistent"
        anchor="left"
        open={innerDrawerOpen}
        onClose={() => setInnerDrawerOpen(false)}
      >
        <MainCard
          sx={{ bgcolor: drawerBG, borderRadius: '12px 0 0 12px', borderRight: 'none' }}
          border
          content={false}
        >
          <Box sx={{ p: 1, pb: 1 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <OutlinedInput
                size="small"
                id="input-search-header"
                placeholder="Search"
                value={search}
                onChange={handleSearch}
                sx={{
                  // flexGrow: 1,
                  minWidth: 120,
                  maxWidth: 230,
                  background: '#fff',
                  borderRadius: 1,
                  boxShadow: '0 1px 2px rgba(60,60,60,0.04)',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d1d5db',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  },
                  height: 40
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton size="small" edge="end" sx={{ p: 0.5 }}>
                      <SearchNormal1 style={{ fontSize: 18, color: '#4B5563' }} />
                    </IconButton>
                  </InputAdornment>
                }
              />
              {clientOptions.length >= 2 && (
                <ClientFilter
                  clientOptions={clientOptions}
                  selectedClient={client}
                  onChange={(clientId) => {
                    setClient(clientId);
                    setPagination({ page: 0, size: pagination.size });
                  }}
                  size="small"
                  sx={{ 
                    background: '#fff', 
                    borderRadius: 1, 
                    height: 40,
                    minWidth: 90,
                    maxWidth: 120
                  }}
                  showAll={true}
                />
              )}
              <PermissionWrapper permission={PERMISSIONS.ADD_EDIT_PROCESS} disableInsteadOfHide={true}>
                <Button
                  type="button"
                  onClick={() => {
                    onClickAction(null);
                  }}
                  sx={{
                    color: '#fff',
                    bgcolor: 'secondary.dark',
                    '&:hover': {
                      bgcolor: 'secondary.main'
                    },
                    minWidth: 60,
                    height: 40,
                    fontWeight: 600,
                    fontSize: 16,
                    boxShadow: '0 1px 2px rgba(60,60,60,0.04)'
                  }}
                  variant="contained"
                >
                  Add
                </Button>
              </PermissionWrapper>
            </Stack>
          </Box>
          {
            <SimpleBar sx={{
                overflowX: 'hidden',
                height: 'calc(100vh - 250px)',
                minHeight: 'calc(100vh - 250px)'
              }}
            >
                <Box sx={{ p: 3, pt: 0, height: '40vh', 'scrollbarColor': '#bdbdbd #f0f0f0',
                '::-webkit-scrollbar': {
        width: '8px',
        backgroundColor: '#f0f0f0',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#bdbdbd',
        borderRadius: '4px',
      },
               }}>
                <TeamsList teams={teams} teamUid={teamUid} loading={teamLoading}/>
              </Box>
            </SimpleBar>
          }
          <CardActions>
            <TablePagination
              component="div"
              count={pageCount}
              page={pagination.page}
              onPageChange={handleChangePage}
              rowsPerPage={pagination.size}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage=""
            />
          </CardActions>
        </MainCard>
      </Drawer>
      </Box>
      <MainCard
        content={false}
        sx={{
          bgcolor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'grey.50',
          pt: 2,
          borderRadius: innerDrawerOpen ? '0 12px 12px 0' : '12px',
          width: '100%',
          marginLeft: innerDrawerOpen ? 0 : 3,
          transition: 'all 0.3s ease',
        }}
      >
        {showForm && (
          <Grid container spacing={3}>
            <Grid item xs={12} sx={{ bgcolor: 'background.paper', pr: 2, pb: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
              <Grid container justifyContent="space-between" spacing={1.5}>
                <Grid item>
                <Box sx={{ marginLeft: "30px" }}>
                  <ChatHeader selected={selectedTeam} loading={false} user={null} handleDrawerOpen={handleDrawerOpen} />
                </Box>
              </Grid>
                <Grid item>
                  <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1}>
                    {teamUid && (
                      <>
                      <Tabs
                        sx={{
                          minHeight: '40px',
                          '& .MuiTabs-indicator': {
                            display: 'none'
                          },
                          '& .MuiTabs-flexContainer': {
                            alignItems: 'center'
                          },
                          '& .MuiButtonBase-root.MuiTab-root': {
                            minHeight: '40px',
                            paddingTop: '6px',
                            paddingBottom: '6px'
                          }
                        }}
                        value={PRIMARY_TAB_VALUES.includes(tabSelected) ? tabSelected : false}
                        onChange={handleTabChange}
                        aria-label="process settings sections"
                      >
                        <StyledTab
                          icon={<TableDocument size="24" color={tabSelected != 'details' ? theme.palette.text.primary : '#fff'} />}
                          iconPosition="start"
                          label="Details"
                          value="details"
                          sx={{
                            backgroundColor: tabSelected === 'details' ? 'secondary.dark' : theme.palette.grey[300],
                            // color: tabSelected === 'details' ? theme.palette.text.primary : 'text.main',
                            '&:hover': {
                              backgroundColor: tabSelected === 'details' ? theme.palette.grey[400] : 'secondary.main',
                              color: 'text.main'
                            },
                            '&.Mui-selected': {
                              backgroundColor: theme.palette.secondary.dark,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff'
                              }
                            }
                          }}
                        />
                        {/* <StyledTab
                          icon={<Profile2User size="24" color={tabSelected !== 'users' ? theme.palette.text.primary : '#fff'} />}
                          iconPosition="start"
                          label="Users"
                          value="users"
                          sx={{
                            backgroundColor: tabSelected === 'users' ? 'secondary.dark' : theme.palette.grey[300],
                            // color: tabSelected === 'details' ? theme.palette.text.primary : 'text.main',
                            '&:hover': {
                              backgroundColor: tabSelected === 'users' ? theme.palette.grey[400] : 'secondary.main',
                              color: 'text.main'
                            },
                            '&.Mui-selected': {
                              backgroundColor: theme.palette.secondary.dark,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff'
                              }
                            }
                          }}
                        /> */}
                        <StyledTab
                          icon={<Hierarchy3 size="24" color={tabSelected !== 'flow' ? theme.palette.text.primary : '#fff'} />}
                          iconPosition="start"
                          label="Flow"
                          value="flow"
                          sx={{
                            backgroundColor: tabSelected === 'flow' ? 'secondary.dark' : theme.palette.grey[300],
                            // color: tabSelected === 'details' ? theme.palette.text.primary : 'text.main',
                            '&:hover': {
                              backgroundColor: tabSelected === 'flow' ? theme.palette.grey[400] : 'secondary.main',
                              color: 'text.main'
                            },
                            '&.Mui-selected': {
                              backgroundColor: theme.palette.secondary.dark,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff'
                              }
                            }
                          }}
                        />
                        <StyledTab
                          icon={<ChecklistIcon sx={{ fontSize: 24, color: tabSelected === 'defaultSteps' ? '#fff' : theme.palette.text.primary }} />}
                          iconPosition="start"
                          label="Default Steps"
                          value="defaultSteps"
                          sx={{
                            backgroundColor: tabSelected === 'defaultSteps' ? 'secondary.dark' : theme.palette.grey[300],
                            '&:hover': {
                              backgroundColor: tabSelected === 'defaultSteps' ? theme.palette.grey[400] : 'secondary.main',
                              color: 'text.main'
                            },
                            '&.Mui-selected': {
                              backgroundColor: theme.palette.secondary.dark,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff'
                              }
                            }
                          }}
                        />
                        {/* Notifications + Clone now live in the "More" dropdown (MORE_TABS) */}
                      </Tabs>
                      <Button
                        onClick={handleMoreOpen}
                        endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 20 }} />}
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          minHeight: '40px',
                          height: '40px',
                          px: '14px',
                          py: 0,
                          ml: '5px',
                          alignSelf: 'center',
                          fontWeight: 500,
                          backgroundColor: activeMoreTab ? 'secondary.dark' : theme.palette.grey[300],
                          color: activeMoreTab ? '#fff' : theme.palette.text.primary,
                          '& .MuiButton-endIcon': { ml: '2px' },
                          '&:hover': {
                            backgroundColor: activeMoreTab ? theme.palette.grey[400] : 'secondary.main',
                            color: activeMoreTab ? '#fff' : 'text.main'
                          }
                        }}
                      >
                        {activeMoreTab ? activeMoreTab.label : 'More'}
                      </Button>
                      <Menu
                        anchorEl={moreAnchorEl}
                        open={Boolean(moreAnchorEl)}
                        onClose={handleMoreClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      >
                        {MORE_TABS.map((t) => (
                          <MenuItem
                            key={t.value}
                            selected={tabSelected === t.value}
                            onClick={() => handleMoreSelect(t.value)}
                          >
                            {t.label}
                          </MenuItem>
                        ))}
                      </Menu>
                      </>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
        {showForm && tabSelected === 'details' &&( 
          <TeamForm selected={selectedTeam} resetForm={resetForm} teamUid={teamUid} />
        )}
        {/* {showForm && tabSelected === 'users' && selectedTeam && <ManageTeamUsers teamUid={teamUid!} client={client} />} */}
        {showForm && tabSelected === 'flow' && teamUid && (
          <QuikFlowPage />
        )}
        {showForm && tabSelected === 'notifications' && teamUid && clientUID && (
          <TeamNotificationSettings clientUID={clientUID} teamUid={teamUid} />
        )}
        {showForm && tabSelected === 'sheets' && teamUid && clientUID &&<SmartSheetConfig  teamUid={teamUid} client={clientUID} teamData={selectedTeam} loadTeamById={loadTeamById} />}
        {showForm && tabSelected === 'clone' && teamUid && (
          <TeamClone teamUid={teamUid} onCloned={loadTeams} />
        )}
        {showForm && tabSelected === 'hideFormFields' && teamUid && clientUID &&
          <HideFormFields clientUID={clientUID} teamUid={teamUid}/>
        }
        {showForm && tabSelected === 'assignmentMessaging' && teamUid && clientUID &&
          <AssignmentMessaging clientUID={clientUID} teamUid={teamUid}/>
        }
        {showForm && tabSelected === 'detection' && teamUid && (
          <DetectionSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'objectDetection' && teamUid && (
          <ObjectDetectionSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'verification' && teamUid && (
          <VerificationSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'defaultSteps' && teamUid && (
          <DefaultStepsSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'monitoring' && teamUid && (
          <MonitoringSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'locationTracking' && teamUid && (
          <LocationTrackingSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'escalationDefault' && teamUid && (
          <EscalationDefaultSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {showForm && tabSelected === 'childStartStep' && teamUid && (
          <ChildTxnStartStepSettings teamUid={teamUid} clientUID={clientUID || undefined} />
        )}
        {!showForm && !isLoading && <FormPlaceholder onClickAction={onClickAction} />}
        {isLoading && <LoadingPlaceholder />}
      </MainCard>
      
    </Box>
  );
};

export default TeamsPage;
